import _ from 'lodash';
import { ChartType } from '../../types/prism';
const stackedChartTypes = [
    ChartType.StackedArea,
    ChartType.StackedColumn,
    ChartType.StackedBar,
    ChartType.LineStackedColumn,
];
const isStackedChart = (chartType) => stackedChartTypes.includes(chartType);
const getUpdatedConditionalMetric = (conditionalFormat) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    if (!conditionalFormat) {
        return null;
    }
    return {
        __typename: 'ConditionalMetric',
        backgroundFormatType: (_a = conditionalFormat.backgroundFormatType) !== null && _a !== void 0 ? _a : null,
        fontProperties: conditionalFormat.fontProperties
            ? {
                __typename: 'FontAttrs',
                bold: (_b = conditionalFormat.fontProperties.bold) !== null && _b !== void 0 ? _b : null,
                color: (_c = conditionalFormat.fontProperties.color) !== null && _c !== void 0 ? _c : null,
                italic: (_d = conditionalFormat.fontProperties.italic) !== null && _d !== void 0 ? _d : null,
                strikeThrough: (_e = conditionalFormat.fontProperties.strikeThrough) !== null && _e !== void 0 ? _e : null,
                underline: (_f = conditionalFormat.fontProperties.underline) !== null && _f !== void 0 ? _f : null,
            }
            : null,
        gradientBackgroundAttrs: conditionalFormat.gradientBackgroundAttrs
            ? {
                __typename: 'GradientBackgroundAttrs',
                colors: conditionalFormat.gradientBackgroundAttrs.colors || null,
                backgroundFormatRange: conditionalFormat.gradientBackgroundAttrs
                    .backgroundFormatRange || null,
                backgroundFormatMidpoint: conditionalFormat.gradientBackgroundAttrs
                    .backgroundFormatMidpoint || null,
                isAutoScaled: (_g = conditionalFormat.gradientBackgroundAttrs.isAutoScaled) !== null && _g !== void 0 ? _g : null,
            }
            : null,
        operator: conditionalFormat.operator || null,
        plotAsBand: (_h = conditionalFormat.plotAsBand) !== null && _h !== void 0 ? _h : null,
        rangeValues: conditionalFormat.rangeValues
            ? {
                __typename: 'Range',
                max: (_j = conditionalFormat.rangeValues.max) !== null && _j !== void 0 ? _j : null,
                min: (_k = conditionalFormat.rangeValues.min) !== null && _k !== void 0 ? _k : null,
            }
            : null,
        value: !_.isNil(conditionalFormat.value)
            ? conditionalFormat.value
            : null,
        solidBackgroundAttrs: conditionalFormat.solidBackgroundAttrs
            ? {
                __typename: 'SolidBackgroundAttrs',
                color: conditionalFormat.solidBackgroundAttrs.color || null,
            }
            : null,
        comparisonType: (_l = conditionalFormat.comparisonType) !== null && _l !== void 0 ? _l : null,
        lhsColumnId: (_m = conditionalFormat.lhsColumnId) !== null && _m !== void 0 ? _m : null,
        rhsColumnId: (_o = conditionalFormat.rhsColumnId) !== null && _o !== void 0 ? _o : null,
        comparisonParameterId: (_p = conditionalFormat.comparisonParameterId) !== null && _p !== void 0 ? _p : null,
        isHighlightRow: (_q = conditionalFormat === null || conditionalFormat === void 0 ? void 0 : conditionalFormat.isHighlightRow) !== null && _q !== void 0 ? _q : null,
    };
};
export { isStackedChart, getUpdatedConditionalMetric };
//# sourceMappingURL=common-util.js.map